define('views/menu/mobile_menu',[
    'backbone',
    'views/shared/panel/panel',
    'text!views/menu/mobile_menu.html'
], function(Backbone, PanelView, Template){
    'use strict';

    return PanelView.extend({
        id      : 'mobile-menu-inner-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
        	'click .js-mobile-menu-link'  : 'togglePanel',
        	'click .js-mobile-menu-logout': 'logOut',
        },
        initialize: function(options){
            options = options || {};

            this.is_open = false;
            this.panel_type = 0;
            this.elementName = options.elementName;

            PanelView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());

            this.addMenuLinks();

            return this;
        },

		loadData: function(){},

        addMenuLinks: function(){

            var that = this,
                links = pf.getContent('routes.header.auth.mobile_links');

            if(_.isArray(links)){

                links.forEach(function(link){

                    var item = document.createElement('li'),
                        inner_item = document.createElement('a');

                    if(link.class){
                        item.setAttribute('class', link.class);
                    }

                    if(_.isObject(link.anchor)){

                        inner_item.setAttribute('href', '#' + link.anchor.url);
                        inner_item.setAttribute('class', link.anchor.class);

                        var html = '';

                        if(_.isObject(link.anchor.icon)){

                            html += (pf.getContent(link.anchor.icon) + ' ');

                        }

                        html += link.anchor.text;

                        inner_item.innerHTML = html;

                    }

                    item.appendChild(inner_item);

                    that.$('.js-mobile-menu-links').append(item);

                });

            }

        },

		togglePanel: function(){
            var that = this;

            if(this.is_open){
                
                $('#mobile-menu-inner-container').fadeOut(200, function(){
                    $('#mobile-menu-container').fadeOut();
                });
                // $('#mobile-menu-inner-container').hide('slide', { direction: 'left' }, 300, function(){
                //     $('#mobile-menu-container').fadeOut();
                // });

                $('.js-header-mobile-nav-btn').find('.lines').removeClass('close');

                this.is_open = false;

            } else {

                $('#mobile-menu-container').fadeIn(200, function(){
                    // $('#mobile-menu-inner-container').show('slide', { direction: 'left' }, 300);
                    $('#mobile-menu-inner-container').fadeIn();
                });
                
                this.is_open = true;

            }
			           
		},

		logOut: function(e){
			if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            pf.controller.signOut();

            this.togglePanel();
            
		},

        close: function(){}
    });
});

